import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recepcion',
  templateUrl: './recepcion.component.html',
  styleUrls: ['./recepcion.component.css']
})
export class RecepcionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
